<script setup lang="ts">
import { toRefs } from 'vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';

import RelatiegegevensEmbed from '../RelatiegegevensEmbed.vue';

const props = defineProps<{
  relatienummer: number;
}>();
const { relatienummer } = toRefs(props);
</script>

<template>
  <VPageContainer gap="xs" container-size="deprecated_1600" title="Documenten">
    <RelatiegegevensEmbed :relatienummer="relatienummer" tab="documenten" />
  </VPageContainer>
</template>
